<div class="sb-display-input-checkbox-toggle col-xs-12 ricarica-automatica"
     [ngClass]="{
      'sb-display-input-checkbox-toggle--checked': isChecked(),
      'sb-display-input-checkbox-toggle--lean': lean,
      'sb-display-input-checkbox-toggle--invalid': invalid
     }">

  <div class="container-toggle ricarica-automatica">
    <!-- region Title -->
    <div class="container-head">
      <div class="container-head-toggle">
        <div class="flex">
          <div class="container-head-toggle-title" *ngIf="title" [innerHTML]="title | translate"></div>
          <wt-info-note width="300px" [invert]="false" class="flex__info-note" text="{{info | translate}}"></wt-info-note>
        </div>
      </div>
      <label class="container-checkbox switch">
        <input type="checkbox" [formControl]="control">
        <span class="slider round"></span>
      </label>
    </div>

    <div class="ricarica-automatica-promo" [ngClass]="{'checked': isChecked()}">
      <img src="/assets/images/promo-ricarica-auto.svg">
      <div class="container" *ngIf="isChecked() && !hasDoublePO">
        <span class="title">{{smartTopUpPromo.title}}</span>
      </div>
      <div class="container" *ngIf="!isChecked() && !hasDoublePO">
        <span class="title-not-checked">Attivala gratis e togliti il pensiero della ricarica.</span>
      </div>
      <div class="container" *ngIf="isChecked() && hasDoublePO">
        <p>Inclusi <span class="title">{{deltagiga}} Giga in più</span> al mese con la ricarica automatica attiva!</p>
      </div>
      <div class="container" *ngIf="!isChecked() && hasDoublePO">
        <p>Attiva la ricarica automatica per avere <span class="title">{{deltagiga}} Giga in più</span> al mese!</p>
      </div>
    </div>

    <!-- endregion -->
  </div>
</div>

